// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const notificationsBorderSize = "1px";
export const notificationsMaxHeightMobile = "calc(90vh - 80px - 1.71rem - 1px)";
export const notificationsExpandTime = "650ms";
export const notificationTray = "NotificationTray__notificationTray__NgYIw";
export const animated = "NotificationTray__animated__sGNlG";
export const sidebarMode = "NotificationTray__sidebarMode__rBdqB";
export const settingsMode = "NotificationTray__settingsMode__nAzVX";
export const positionRelative = "NotificationTray__positionRelative__RU8fD";
export const notificationTrayInner = "NotificationTray__notificationTrayInner__L066j";
export const visible = "NotificationTray__visible__zilDm";
export const scrollable = "NotificationTray__scrollable__igOX8";
export const itemList = "NotificationTray__itemList__+k4WE";
export const desktopButtonWrapper = "NotificationTray__desktopButtonWrapper__MUtVh";
export const hidden = "NotificationTray__hidden__oHUXw";
export const item = "NotificationTray__item__B0zMM";
export const enter = "NotificationTray__enter__CqyLP";
export const leaveActive = "NotificationTray__leaveActive__G4ttw";
export const enterActive = "NotificationTray__enterActive__GeRH3";
export const leave = "NotificationTray__leave__6euLv";
export const itemInner = "NotificationTray__itemInner__6fIVG";
export const itemContent = "NotificationTray__itemContent__YcDmR";
export const icon = "NotificationTray__icon__pvB9c";
export const iconInRow = "NotificationTray__iconInRow__NOtFg";
export const itemText = "NotificationTray__itemText__-bIWw Text__bodyText__20Sxx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const withIcon = "NotificationTray__withIcon__ooA17";
export const buttons = "NotificationTray__buttons__pRST6";
export const liveUpdateButtonWrapper = "NotificationTray__liveUpdateButtonWrapper__Y4SNP";